export default { 
  inputPhone: require('./inputPhone').default,
}